module.exports = __webpack_public_path__ + "static/img/5.b3c9128.png";


//////////////////
// WEBPACK FOOTER
// ./static/Brand/Main/5.png
// module id = 271
// module chunks = 18